import React, { useState } from "react"
import { useIntl } from "react-intl"
import {
	DataTable,
	DataTableBody,
	DataTableCellAlphaNumeric,
	DataTableHead,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import ChartContainer from "components/Shared/ChartContainer"
import "./CrossSellingRankingTable.scss"
import { concatClassNames } from "helpers/jsxHelpers"
import { CrossSellingRankingNode } from "components/Transactional/CrossSelling/interfaces"
import { ITEMS_PER_PAGE, TableHeader } from "./RankingTableConfig"
import Paginator, { usePaginationLocal } from "components/Shared/Paginator"
import DataHeader from "components/Shared/InformationTable/DataHeader"
import useGetFormattedRanking from "./hooks/useGetFormattedRanking"
import { ExportCSV } from "components/Shared/ExportCSV"

type CrossSellingRankingTableProps = {
	data: CrossSellingRankingNode[]
}

const CrossSellingRankingTable = (props: CrossSellingRankingTableProps) => {
	const intl = useIntl()
	const { data } = props
	const [dataTable, setDataTable] = useState<CrossSellingRankingNode[]>(data)
	const { currentData, getPaginatorProps } = usePaginationLocal<
		CrossSellingRankingNode
	>({
		data: dataTable,
		itemsPerPage: ITEMS_PER_PAGE,
	})
	const columnsHeader = TableHeader.map(
		({ id, classnames = [], width = undefined, columnName }) => ({
			name: intl.formatMessage({ id }),
			alignment: "left",
			nameColumnSort: columnName,
			hasSort: true,
			className: concatClassNames(["header", ...classnames]),
			width,
		})
	)

	React.useEffect(() => {
		setDataTable(data)
	}, [JSON.stringify(data)])

	return (
		<div className="cross-selling-ranking">
			<ChartContainer
				title={{
					id:
						"phronesis.transactional.application.cross-selling.cross-ranking.title",
				}}
				body={{
					id:
						"phronesis.transactional.application.cross-selling.cross-ranking.description",
				}}
			>
				<ExportCSV
					fileName={"ranking_cross_selling"}
					data={useGetFormattedRanking(data)}
					name={"phronesis.transactional.application.cross-selling.download"}
					align={"right"}
				/>

				<DataTable UNSAFE_className="cross-selling-ranking-table">
					<DataTableHead>
						<DataTableRow>
							<DataHeader
								dataTable={data}
								columnsHeader={columnsHeader}
								onSort={(data) => setDataTable(data)}
							/>
						</DataTableRow>
					</DataTableHead>
					<DataTableBody>
						{useGetFormattedRanking(currentData).map((item) => (
							<DataTableRow
								key={`${item.ranking}`}
								data-testid="cross-selling-ranking-row"
							>
								{Object.entries(item).map(([k, v]) => {
									return (
										<DataTableCellAlphaNumeric key={k}>
											{v}
										</DataTableCellAlphaNumeric>
									)
								})}
							</DataTableRow>
						))}
					</DataTableBody>
				</DataTable>
				<Paginator {...getPaginatorProps()} />
			</ChartContainer>
		</div>
	)
}

export default CrossSellingRankingTable
